import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import React from 'react';

interface ClearInputButtonProps {
  onClick: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  ariaLabel: string;
}

export const ClearInputButton: React.FC<ClearInputButtonProps> = ({
  onClick,
  ariaLabel,
}) => (
  <button
    aria-label={ariaLabel}
    onClick={onClick}
    style={{
      background: 'none',
      border: 'none',
      padding: 0,
      margin: 0,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
    }}
    tabIndex={0}
    type="button"
  >
    <IconSymbol color="#4B4D4F" icon="cancel" size="18px" variant="outlined" />
  </button>
);
